const calcValuesByHa = (ha: number, service: string, newCalc = false) => {
  if (newCalc) {
    let percent;
    switch(service) {
      case 'completeEvu':
        percent = 1;
        break;
      case 'directorPlan':
        return 1500;
        break;
      case 'concept':
        percent = 1.5;
        break;
      case 'dwgStudy':
        percent = 4;
        break;
      case 'downloadStudy':
        return 200;
      default:
        percent = 0;
    }
    switch (true) {
      case (ha <=20):
        return 3835.91 * percent;
      case (ha <= 2000):
        return ((3835.91 + (19464.55/980) * (ha - 20)) * percent);
        case (ha >= 2000):
          return 0;
      default:
        return 0;
    }
  } else {
    if (service === 'completeEvu') {
      switch (true) {
        case (ha < 25):
          return 3500;
        case (ha >= 25 && ha < 50):
          return 4000;
        case (ha >= 50 && ha < 75):
          return 4500;
        case (ha >= 75 && ha < 100):
          return 5000;
        case (ha >= 100 && ha < 150):
          return 5500;
        case (ha >= 150 && ha < 250):
          return 7000;
        case (ha >= 250 && ha < 450):
          return 8000;
        case (ha >= 450 && ha < 650):
          return 9000;
        case (ha >= 650):
          let value = 9000;
          let newHa = ha - 650;
          newHa = newHa / 100;
          newHa = newHa | 0;
          if (newHa >= 1) {
            value = value + newHa * 5000
          }
          return value;
      }
    } else if (service === 'directorPlan') {
      return 500;
    } else if (service === 'concept') {
      switch (true) {
        case (ha < 25):
          return 1750;
        case (ha >= 25 && ha < 50):
          return 2000;
        case (ha >= 50 && ha < 75):
          return 2250;
        case (ha >= 75 && ha < 100):
          return 2500;
        case (ha >= 100 && ha < 150):
          return 2750;
        case (ha >= 150 && ha < 250):
          return 3500;
        case (ha >= 250 && ha < 450):
          return 4000;
        case (ha >= 450 && ha < 650):
          return 4500;
        case (ha >= 650):
          let value = 450;
          let newHa = ha - 650;
          newHa = newHa / 100;
          newHa = newHa | 0;
          if (newHa >= 1) {
            value = value + newHa * 2500
          }
          return value;
      }
    } else if (service === 'dwgStudy') {
      return 500;
    } else {
      return 0;
    }
  }
}

export { calcValuesByHa };
